module.exports = __webpack_public_path__ + "static/media/133.bf8f3ee0.png";